import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiListResponseModel, ApiService } from "../core";
import {
  CreateDigitalCouponsRequestDto,
  ImportedCouponCodeMode,
  ImportedCouponDetailDto,
  ImportedCouponGetDto,
  ImportedCouponGridRequestDto,
  ImportedCouponTypeDto
} from "../dto";

@Injectable()
export class ImportedCouponService {
  protected serviceUrl = "imported/coupons";

  constructor(protected api: ApiService) {}

  getList(request: ImportedCouponGridRequestDto): Observable<ApiListResponseModel<ImportedCouponGetDto[]>> {
    return this.api.postList(this.serviceUrl, request);
  }

  getById(id: number): Observable<ImportedCouponDetailDto> {
    return this.api.get<ImportedCouponDetailDto>(`${this.serviceUrl}/${id}`);
  }

  getCouponTypes(couponCodeMode: ImportedCouponCodeMode): Observable<ImportedCouponTypeDto[]> {
    return this.api.get<ImportedCouponTypeDto[]>(`${this.serviceUrl}/types`, { couponCodeMode });
  }

  createDigitalCoupons(body: CreateDigitalCouponsRequestDto): Observable<void> {
    return this.api.post<void>(`${this.serviceUrl}/create`, body);
  }
}
